var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-input',_vm._b({on:{"input":function($event){_vm.search = $event.target.value},"reset":function($event){_vm.search = ''}}},'v-input',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }